<template>
  <div class="body">
    <header>
      <div class="title">
        <div class="title_left" style="display: flex;align-items: center">
          <img src="../../model/Images/logo.png" style="width: 40px;height: 40px;margin-right: 10px" alt="">
          瀚洋电信统一管理平台
        </div>
        <div class="title_right">
          <div @click="(()=>this.$router.back())">返回</div>
        </div>
      </div>
    </header>
    <div class="main">
      <el-tabs style="min-height: 100vh!important" type="border-card">
        <el-tab-pane style="font-size: 16px!important" :label="title">
          <div style="width: 100%;padding: 0 30px 0 30px;box-sizing: border-box">
            <div v-for="o in 20" :key="o" style="padding: 10px 0">
              <div style="font-size: 14px;width: 100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding-right: 10px;box-sizing: border-box"><i style="margin-right: 10px" class="el-icon-caret-right"/>{{'这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告这是公司公告' + o }}</div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'announcement',
  components: {
  },
  data () {
    return {
      title: ''
    }
  },
  created () {
    const title = this.$route.query
    if (title) {
      switch (title) {
        case '1':
          this.title = '公司公告'
          break
        case '2':
          this.title = '上海公告'
          break
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .body {

    header {
      width: 100%;
      height: 10vh;
      line-height: 10vh;
      background-color: #0a4b9d;

      .title {
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;

        .title_left {
          font-size: 30px;
          font-weight: 700;
          color: #fff;
        }

        .title_right {
          display: flex;
          justify-content: space-between;
          align-items: center;

          div {
            font-size: 13px;
            color: #fff;
            margin-left: 20px;
          }
        }
      }
    }
    .main {
      width: 80%;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/More.vue